import { useQuery } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_ACCOUNT_TEAM = (teamId: number | undefined) => ['account-team', teamId] as const;

export function useSettingsTeam() {
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();

  return useQuery({
    queryKey: QK_ACCOUNT_TEAM(teamId),
    queryFn: () => accountApi.team(teamId).get(),
    enabled: teamId !== undefined,
  });
}
